import React from 'react'
import './NoRecordsFound.css'
import { useTranslation } from 'react-i18next'
import { Button } from '@material-ui/core'
import { handleRedirectInternal } from '../../../common/components'
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min'
function NoRecordsFound(props) {
    const { t } = useTranslation()
    const history = useHistory()
    const isVarifiedGfTheme = global.storeConfigration?.bodyClass?.value === 'greenField'
    return (
        <>
            <h4 className="noRecordsFound">
                <span className="material-icons">find_in_page</span>
                {props?.text
                    ? props.text
                    : global.storeDetails?.theme == 20
                    ? 'Oops! Nothing Found.'
                    : isVarifiedGfTheme
                    ? 'Sorry we did not have exactly what you were looking for'
                    : t('No_Records')}
            </h4>
            {isVarifiedGfTheme && (
                <Button
                    className="noRecordBtn mb-3"
                    onClick={() => handleRedirectInternal(history, 'search')}
                >
                    Please checkout out our other auctions
                </Button>
            )}
        </>
    )
}

export default NoRecordsFound
